// @flow

import { fetchRest } from "../../rest/rest";

import { event } from "../../utils/events";

export const FETCH_MONTHLY_PHOTOS_SUCCESS = "state.blogs.FETCH_MONTHLY_PHOTOS_SUCCESS";
export const FETCH_MONTHLY_PHOTOS_ERROR = "state.blogs.FETCH_MONTHLY_PHOTOS_ERROR";
export const FETCH_PHOTOS_SUCCESS = "state.blogs.FETCH_PHOTOS_SUCCESS";
export const FETCH_PHOTOS_ERROR = "state.blogs.FETCH_PHOTOS_ERROR";
export const SHOW_MONTH = "state.blogs.SHOW_MONTH";
export const HIDE_MONTH = "state.blogs.HIDE_MONTH";

export const fetchMonthlyPhotos = () => async dispatch => {
    try {
        const months = await fetchRest("imagemonths");

        dispatch({ type: FETCH_MONTHLY_PHOTOS_SUCCESS, payload: months });
    } catch (err) {
        err.message = `Unable to retrieve monthly photos: ${err.message}`;
        console.log(err);
        dispatch({ type: FETCH_MONTHLY_PHOTOS_ERROR, payload: err });
    }
};

export const fetchPhotos = photoSummary => async dispatch => {
    try {
        const photos = await fetchRest("images", {
            startDate: photoSummary.startDate,
            endDate: photoSummary.endDate
        });
        dispatch({ type: FETCH_PHOTOS_SUCCESS, payload: { photoSummary, photos } });
    } catch (err) {
        err.message = `Unable to retrieve images: ${err.message}`;
        throw err;
    }
};

export const showMonth = photoSummary => async dispatch => {
    dispatch({ type: SHOW_MONTH, payload: photoSummary });

    if (photoSummary.photos === undefined) {
        dispatch(fetchPhotos(photoSummary));
    }

    event({
        category: "Browse",
        action: "Show Photo Month"
    });
};

export const hideMonth = () => async dispatch => {
    dispatch({ type: HIDE_MONTH });

    event({
        category: "Browse",
        action: "Hide Photo Month"
    });
};



// WEBPACK FOOTER //
// ./src/state/photos/actions.js